export const Colors = {
    HeroGradient: {
        DustNight: '#1E201E, #3C3D37, #697565, #ECDFCC',
        Sky: '#BBE1FA, #3282B8, #0F4C75, #1B262C'
    },
    SmokeWhite: '#F5F5F5',
    PureWhite: '#FFF'
}

export const dateFormats = {
    dayMonthYear: 'dd MMMM yyyy'
}

export const MyCV = 'My CV'

export const personalData = {
    email: 'felichavarria@hotmail.com'
}

export const home = {
    aboutMeDescription: 'My name is Felipe Chavarria, I’m a Software Developer based in Uruguay. I enjoy turning real-world requirements into code. I always strive to write high-quality code and I see continuous learning as a core part of my work.'
}

export const GAID = 'G-17H7EM7KLT'